$(document).on('click', '[data-sync]', function (e) {
    if (e.isTrigger === 3) return;
    e.preventDefault();

    const event = $(this).data('sync-event'),
        element = $($(this).data('sync')),
        params = $(this).data('sync-params');

    element[event](params);

});